import { aeVersion } from 'workspaces/launcher/utils/BuildVersion';

const ClientNames = {
  PILOT: 'Automation Engine Client ' + aeVersion,
  SCRIPT_RUNNER: 'Automation Engine Script Runner ' + aeVersion,
  ARTPRO_ACTIONLIST_EDITOR: 'Automation Engine ArtPro Action List Editor 23.11',
  PITSTOP_PROFILE_EDITOR: 'Automation Engine PitStop Profile Editor ' + aeVersion,
  AE_10_BACKUP: 'Automation Engine 10 Backup',
  AE_AGENT: 'Automation Engine Agent ' + aeVersion,
  EDITOR_CONNECTION_TOOLS: 'Automation Engine Editor Connection Tools ' + aeVersion,
  FLEXO_WORKFLOW_EDITORS: 'FlexoWorkflowEditors26.03'
};

export default ClientNames;
